import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { FieldModel } from '@models/module/fields/main';
import { FieldTypeIndicatorComponent, FieldTypeIndicatorField } from '@shared/components/field-type-indicator';

import { fieldCardBackground } from './field-card-background';

export type FieldCardField = Pick<FieldModel, 'name' | 'label'> &
  FieldTypeIndicatorField &
  Partial<Pick<FieldModel, 'id' | 'fieldOrigin' | 'isContractSystemField'>>;

@Component({
  selector: 'cipo-field-card',
  imports: [FieldTypeIndicatorComponent],
  templateUrl: './field-card.component.html',
  styleUrl: './field-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'cipo-outlined-field p-y-sm p-x-sm',
    '[class.cipo-mark-changed]': 'changed()',
    '[style.background-color]': 'background()',
    '[attr.data-field-id]': 'field().id',
  },
})
export class FieldCardComponent {
  readonly field = input.required<FieldCardField>();
  readonly changed = input(false);
  readonly outlineLabel = input<string>();

  readonly heading = computed(() => this.outlineLabel() ?? this.field().name);
  readonly background = computed(() => fieldCardBackground(this.field()));
}
